import { FAB as RNFAB, type FABProps as RNFABProps } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";

export type FABProps = RNFABProps;

export const FAB = ({ uppercase, ...props }: FABProps) => {
	const theme = useAppTheme();

	const isUpperCase =
		uppercase ??
		theme.componentOverrides?.button?.labelStyle?.textTransform === "uppercase";

	return <RNFAB {...props} uppercase={isUpperCase} />;
};

FAB.Group = RNFAB.Group;
